import React from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import BlueCardReportView from "../../BlueCardReport/BlueCardReportView";
import { languageService } from "../../../Language/language.service";
import SvgIcon from "react-icons-kit";
import { printer } from "react-icons-kit/icomoon/printer";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import _ from "lodash";
import { getFormSummary } from "../../Reports/utils/getFormSummary";

class BlueCardCertificationDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reviewBlueCardData: {},
      blueCardFrequencyLookup: {},
    };
  }

  componentDidMount() {
    let blueCardForms = [];
    let blueCardFrequencyLookup = {};
    this.props.applicationlookupss.forEach((lookup) => {
      if (lookup && lookup.opt1) {
        let forms = lookup.opt1.forms ? lookup.opt1.forms : [];
        blueCardForms.push(...forms);
        forms.forEach((f) => {
          blueCardFrequencyLookup[f] = lookup.opt1.frequency;
        });
      }
    });
    this.setState({
      isBlueCardTest: blueCardForms.includes(this.props.form) ? true : false,
      blueCardFrequencyLookup: blueCardFrequencyLookup,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.actionType === "BLUECARDCERTIFICATIONDETAILS_READ_SUCCESS" && this.props.actionType !== prevProps.actionType) {
      console.log("run");
      this.injectBlueCardReviewDetails(this.props.selectedReviewBlueCard, this.props.selectedReviewBlueCardDetails);
    }
  }

  injectBlueCardReviewDetails(blueCardData, blueCardReviewDetails) {
    const { testsPendingReview, oouPendingReview } = blueCardReviewDetails;

    let updatedBlueCardData = this.injectTestsData(blueCardData, testsPendingReview);

    let injectedBlueCardData = this.injectOOSData(updatedBlueCardData, oouPendingReview);

    this.setState({ reviewBlueCardData: injectedBlueCardData });
  }

  injectTestsData(blueCardData, inspectionTests, noOfDays) {
    const enhanced = JSON.parse(JSON.stringify(blueCardData));
    if (!enhanced.summary) enhanced.summary = {};
    let certifyUserList = [];
    let certifyTestSchedules = [];
    inspectionTests.forEach((test, index) => {
      const testCode = test.testCode;
      if (!testCode) return;
      let isLastTest = index === inspectionTests.length - 1;
      const formDataObj = getFormSummary({ form: test.formData });
      const numPeriods = this.getNoOfPeriods(testCode);
      const userName = (test.user && test.user.name) || "";
      if (!certifyUserList.some((u) => u.id === (test.user && test.user.id))) {
        certifyUserList.push(test.user);
      }
      certifyTestSchedules.push(test._id.toString());
      const periodData = {
        Date: new Date(),
        Place: formDataObj.locationName || "",
        Name: userName,
        noOfDays: noOfDays,
        Id: test._id.toString(),
        FormData: { ...formDataObj },
        Cert: test.otherInfo && test.otherInfo.certifiedBy,
        blueCardCertify: { pendingCertify: true, userList: certifyUserList, testSchedulesList: certifyTestSchedules },
      };

      let updatedSummaryData = this.injectPeriod(enhanced.summary[testCode], numPeriods, periodData);
      enhanced.summary[testCode] = {
        ...updatedSummaryData,
      };
    });

    return enhanced;
  }

  getNoOfPeriods(key) {
    let noOfPeriods = null;
    noOfPeriods = this.state.blueCardFrequencyLookup[key];
    return noOfPeriods;
  }

  injectPeriod(data, limit, newPeriod) {
    const originalData = data && typeof data === "object" ? data : {};
    const periods = [];
    for (let i = 1; originalData[`period${i}Id`] !== undefined; i++) {
      periods.push({
        Date: originalData[`period${i}Date`],
        Name: originalData[`period${i}Name`],
        Cert: originalData[`period${i}Cert`] || "",
        Place: originalData[`period${i}Place`],
        Id: originalData[`period${i}Id`],
        FormData: originalData[`period${i}FormData`],
        blueCardCertify: originalData[`period${i}blueCardCertify`],
      });
    }
    if (limit !== null && periods.length >= limit) {
      periods.shift();
    }
    periods.push(newPeriod);
    const newData = { ...originalData };
    newData[`noOfDays`] = newPeriod.noOfDays;
    newData[`testConfigured`] = true;
    periods.forEach((period, index) => {
      const idx = index + 1;
      period.Date && (newData[`period${idx}Date`] = period.Date);
      newData[`period${idx}Name`] = period.Name;
      newData[`period${idx}Cert`] = period.Cert;
      newData[`period${idx}Place`] = period.Place;
      newData[`period${idx}Id`] = period.Id;
      newData[`period${idx}FormData`] = period.FormData;
      period.blueCardCertify && (newData[`period${idx}blueCardCertify`] = period.blueCardCertify);
    });
    return newData;
  }

  injectOOSData(bluecardReport, oosPeriods) {
    if (!bluecardReport) bluecardReport = {};
    if (!oosPeriods) oosPeriods = {};
    const enhanced = { ...bluecardReport };
    const lookupArray = oosPeriods;

    const existingOutOfUse = (enhanced.summary && enhanced.summary.OutOfUse) || {};
    const updatedOutOfUse = { ...existingOutOfUse };

    let periodCount = 0;
    Object.keys(existingOutOfUse).forEach((key) => {
      const match = key.match(/^period(\d+)Data$/);
      if (match) {
        const num = parseInt(match[1], 10);
        if (num > periodCount) periodCount = num;
      }
    });

    updatedOutOfUse.outOfUseCredit = existingOutOfUse.outOfUseCredit || 0;

    lookupArray.forEach((period, idx) => {
      const i = periodCount + idx + 1;

      updatedOutOfUse[`period${i}Id`] = period.id;
      updatedOutOfUse[`period${i}StartDate`] = period.start;
      updatedOutOfUse[`period${i}Data`] = { ...period };
      updatedOutOfUse[`period${i}blueCardCertify`] = { pendingCertify: true };
    });

    enhanced.summary = {
      ...enhanced.summary,
      OutOfUse: updatedOutOfUse,
    };
    return enhanced;
  }

  render() {
    const { selectedYear } = this.props;
    const { reviewBlueCardData } = this.state;

    return (
      <div>
        {/* Back & Print controls */}
        <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
          <div
            className="report-arrow"
            style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
            onClick={(e) => {
              // call onBack prop
              if (this.props.onBack) {
                this.props.onBack();
              }
            }}
          >
            <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
              {languageService("Reports Menu")}
            </span>
            <SvgIcon icon={arrowLeft} size={24} />
          </div>

          <div
            className="report-print"
            style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
            onClick={(e) => window.print()}
          >
            <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
              {languageService("Print Report")}
            </span>
            <SvgIcon icon={printer} size={24} />
          </div>
        </div>

        {reviewBlueCardData && (
          <div style={{ marginTop: "2rem" }}>
            <BlueCardReportView
              reportData={reviewBlueCardData}
              year={selectedYear}
              handleCertifyClick={this.props.onCertify}
              pendingReviewDetails={this.props.selectedReviewBlueCardDetails}
              blueCardSectionsLookups={this.props.applicationlookupss}
              blueCardReview={true}
            />
          </div>
        )}
      </div>
    );
  }
}

let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
};

let variables = {
  applicationlookupsReducer: { applicationlookupss: [] },
};

const BlueCardCertificationDetailContainer = CRUDFunction(
  BlueCardCertificationDetail,
  "BlueCardCertificationDetail",
  actionOptions,
  variables,
  ["applicationlookupsReducer"],
  "blueCard",
);

export default BlueCardCertificationDetailContainer;



// WEBPACK FOOTER //
// ./src/components/ReviewsCertifications/BlueCardsCertification/BlueCardCertificationDetail.jsx